import { FeApi } from '@/api/fe-api';
import {
  type ConditionViolation,
  type ConditionViolationHistoryPoint,
  type ConditionViolationHistorySeries,
} from '@/warranty-v3/entities/condition-violation';

export function conditionViolationHistoryPointMapper(
  data: FeApi.ConditionViolationHistoryPoint,
): ConditionViolationHistoryPoint {
  return [new Date(data.date), data.affected_units];
}

export function conditionViolationHistorySeriesMapper(
  data: FeApi.ConditionViolationHistorySeries,
): ConditionViolationHistorySeries {
  return {
    points: data.points.map(conditionViolationHistoryPointMapper),
  };
}

export function conditionViolationMapper(
  data: FeApi.ConditionViolation,
): ConditionViolation {
  return {
    id: data.id,
    description: data.description,
    extremeValue: data.extreme_value,
    extremeValueUnit: data.extreme_value_unit,
    lastDetectedAt: new Date(data.last_detected_at),
    durationHours: data.duration_hours,
    affectedUnitsCount: data.affected_units_count,
    historySeries: conditionViolationHistorySeriesMapper(data.history_series),
  };
}

export function conditionViolationsMapper(
  data: FeApi.ConditionViolation[],
): ConditionViolation[] {
  return data.map(conditionViolationMapper);
}
